import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import Scrollbar from 'react-smooth-scrollbar';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SidebarContent from './SidebarContent';
import { SidebarProps } from '../../../shared/prop-types/ReducerProps';
import { changeSidebarVisibility } from '../../../redux/actions/sidebarActions';
import SidebarProfile from './SidebarProfile';

const Sidebar = ({
  changeToDark,
  changeToLight,
  changeMobileSidebarVisibility,
  sidebar,
  listOfPermission,
  dispatch,
  loggedUser,
  listOfOperation,
}) => {
  const changeSidebarVisibilityHandler = () => {
    dispatch(changeSidebarVisibility());
  };

  const sidebarClass = classNames({
    sidebar: true,
    'sidebar--show': sidebar.show,
    'sidebar--collapse': sidebar.collapse,
  });

  let menuContent = null;
  if (listOfPermission) {
    menuContent = listOfPermission.map((item) => (
      <SidebarContent
        key={item.id}
        menuName={item.name}
        icon={item.icon}
        childrenMenu={item.children}
        onClick={changeMobileSidebarVisibility}
        changeToDark={changeToDark}
        changeToLight={changeToLight}
      />
    ));
  }

  return (
    <Fragment>
      <div className={sidebarClass}>
        <div>
          <button
            type="button"
            onClick={changeSidebarVisibilityHandler}
            className="logo-button"
          />
        </div>
        <Scrollbar className="sidebar__scroll scroll">
          <div className="sidebar__wrapper sidebar__wrapper--desktop">
            {menuContent}
          </div>
          <div className="sidebar__wrapper sidebar__wrapper--mobile">
            {menuContent}
          </div>
        </Scrollbar>
        <SidebarProfile
          loggedUser={loggedUser}
          listOfOperation={listOfOperation}
          listOfPermission={listOfPermission}
          collapsed={sidebar.collapse}
        />
      </div>
    </Fragment>
  );
};

Sidebar.propTypes = {
  sidebar: SidebarProps.isRequired,
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  listOfPermission: PropTypes.arrayOf(PropTypes.shape).isRequired,
  loggedUser: PropTypes.shape(PropTypes.shape).isRequired,
  listOfOperation: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
    pendingApplications: state.pendingApplications.pendingApplications,
  }))(Sidebar)
);
